require('src/interlock/ui/owl-carousel/ads-owl-carousel');
/**
 * init function
 * @param $owlCarousels - owl carousel elements
 * i.e.
 * var owlCarousels = require('src/interlock/ui/owl-carousel/owl-carousel');
 * owlCarousels.init();
 * --- OR ---
 * var someModuleOwlCarousels = $('SOME_MODULE .owl-carousel');
 * var owlCarousels = require('src/interlock/ui/owl-carousel/owl-carousel');
 * owlCarousels.init(someModuleOwlCarousels);
 */
function init($owlCarousels) {
    var owlCarousel = $owlCarousels ? $owlCarousels : $('.owl-carousel'),
        constants = require('src/interlock/no-ui/constant/carousel'),
        owlCarouselChanged = require('./events/changed'),
        owlCarouselRefreshed = require('./events/refreshed'),
        indexLabels = require('./index-labels'),
        carouselDataOptions = require('./carousel-data'),
        arrowSwipers = require('./arrow-swipers'),
        refresh = require('./customization/refresh'),
        /**
         * Timeout next/prev switch happens with
         * @type {number}
         */
        defaultTimeout = constants.DEFAULT_TIMEOUT,
        DEFAULT_OPTIONS = {
            items: 1,
            lazyLoad: false,
            owlLazy: true,
            loop: true,
            showArrows: true,
            autoplay: false,
            autoplayTimeout: 5000,
            autoplaySpeed: defaultTimeout,
            autoplayHoverPause: true
        };
    // Store a target event type (events below fire before an event 'changed')
    owlCarousel.on('drag.owl.carousel next.owl.carousel prev.owl.carousel to.owl.carousel', function (event) {
        $(this).data('event-type', event.type);
    });

    owlCarousel.on('initialized.owl.carousel', function (event) {
        var $element = $(this);
        // Store total count of slider items
        $element.data('total', event.item.count);

        // Init index labels if enabled
        if (indexLabels.isEnabled($element)) {
            indexLabels.set($element, 0);
        }
    });

    owlCarousel
        .on('translate.owl.carousel', function() {
            owlCarousel.parent().addClass('translating');
        })
        .on('translated.owl.carousel', function() {
            owlCarousel.parent().removeClass('translating');
        });

    owlCarouselRefreshed(owlCarousel);
    owlCarouselChanged(owlCarousel);

    function addOptionHacks(options) {
        // This hack used to solve owl-carousel bug on touch devices when we touch carousel and scroll page.
        // In this case carousel fire touchend event and
        // if autoplayHoverPause is true touchend event handler start autoplay w/o checking if autoplay is on
        if (!options.autoplay) {
            options.autoplayHoverPause = false;
        }
        if (options.pageCounter) {
            options.dots = true;
        }
    }

    function setUpOptions(options, $carousel) {
        addOptionHacks(options);
        if (options.alignArrows) {
            $carousel.siblings('.carousel-control').addClass(options.alignArrows + '-arrows-small');
        }
    }

    /**
     * In a case we have default navigation speed for carousel (defined by mapping in constants) we apply it
     * It can be overridden in atom configuration
     */
    function setUpNavigationSpeedOption(options) {
        if (!options.navigationSpeed) {
            options.navigationSpeed = constants.NAVIGATION_SPEEDS.hasOwnProperty(options.items) ?
                constants.NAVIGATION_SPEEDS[options.items] :
                defaultTimeout;
        }
    }

    var carouselsFontReady = [];
    owlCarousel.each(function(index, carousel) {
        var $carousel = $(carousel),
            carouselData = carouselDataOptions.getCarouselData($carousel),
            options = $.extend({}, DEFAULT_OPTIONS, carouselData);

        setUpOptions(options, $carousel);
        setUpNavigationSpeedOption(options);
        // For further use, e.g. in change events, etc.
        $carousel.data('options', options);

        if (carouselData.carouselType === 'ads') {
            $carousel.adsOwlCarousel(options);
        }
        else {
            $carousel.owlCarousel(options);
        }

        if (options.refreshWhenFontReady) {
            carouselsFontReady.push({carousel: $carousel, refreshWhenFontReady: options.refreshWhenFontReady});
        }
        arrowSwipers($carousel);
    });
    refresh.refreshWhenFontReady(carouselsFontReady);
    require('./owl-carousel-lazy')(owlCarousel);
}

init();

module.exports = {
    init: init
};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/ui/owl-carousel/owl-carousel.js
// module id = 10
// module chunks = 0 1 2 3 4 5 6 7 8 10 11 12 13 14 15 17